<div class="tw-p-8 tw-flex">
  <img class="new-logo-themed" alt="Bitwarden" />
  <div class="spinner-container tw-justify-center">
    <i class="bwi bwi-spinner bwi-spin bwi-3x tw-text-muted" title="Loading" aria-hidden="true"></i>
  </div>
</div>
